module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter 3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("M")]), _vm._v("y name is Jason. It’s the name my mother gave me when I was barely a visible bump in her belly. I’ve always hated that name even more than I hated her. It’s the name on my birth certificate and my passport, on my credit cards and my work pass - but I never use it. I should be named after an all-powerful God, that is, ever since I started to decide whether people should live or die.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("For as long as I can remember I’ve always thought drowning would be fun, but the water here is too cold. Even in the summer months, when the diehard sun worshippers slap on chip fat to roast their parchment-coloured flesh, it’s still too cold.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I live in a place where the grey of the town bleeds into the grey of the sea. Where children trudge along the Promenade with their parents in tow, all of them in search of "), _c('i', [_vm._v("something")]), _vm._v(" to make them happy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But they seldom find it, even in summer.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I like watching the runners in the morning, in their budget trainers, dodging the rain and dog shit as they enrich their lives along the sea front. It is mid-June, in a holiday resort on the west coast of Britain, and the place is empty.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It’s not as though I’ve not tried - drowning that is.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I remember my twelfth birthday, Mum did a beach BBQ. She thought it a good idea having watched it on TV. The fact that the programme depicted life in Brisbane and our miserable lives butted hard up against the Irish Sea seemed to pass her by. The party was all burnt meat, freezing skin and blown sand. In the years that followed, she paid for it dearly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We played games in the biting wind. One involved running into the sea and back to win a prize. I remember thinking - "), _c('i', [_vm._v("what would happen if I kept on running?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I felt the water slapping against my legs, then my stomach, then my chest. I pushed on and the waves caught me full in the face washing my hair flat to my head. If I kept going, I’d be under.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Today I die. ")]), _vm._v("The words resonated deep inside my head. Driving me on. The force of the sea made it hard to stand. The whole world seemed to shift beneath my feet, my toes grasping at the sand for balance. The raw taste of salt in my mouth. And then, suddenly, with a swell of the tide, I was under. A dull silence washed through my head.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even now when I drift off to sleep I can still feel the biting, lapping cold like it was yesterday. I remember thinking - "), _c('i', [_vm._v("if I’m successful, there won’t be any singing Happy Birthday. No, ‘open your presents, Jason.’ No, ‘say thank you, Jason.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("All I heard was the water coursing through my ears, the cold tightening a vice-like grip around my body. The chill tearing at my skin.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Today I die. What a perfect gift on my special day.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But the water was too cold and my mum had bought Iced Slice. And I love Iced Slice. I turned and fought my way back to the shore, fighting against the pull of the waves dragging me further out. Gasping, I reached the beach and looked at the faces of the children wrapped in towels. No one had missed me. I wasn’t going to die today, even if it was my birthday. Besides, I would happily kill for an Iced Slice.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And two years later, I did just that.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8eaa294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter003.vue
// module id = 84
// module chunks = 0